import React from 'react';
import { LoaderContainer, LoaderSpan } from './Loader.style';

/* /!\ If you change something here, change it in the public/index.html too */
export const Loader: React.FunctionComponent = () => {
  return (
    <LoaderContainer>
      <LoaderSpan/>
    </LoaderContainer>
  );
};
